<div class="mx-auto my-8 flex max-w-6xl flex-col gap-4">
  <div>
    <h1 class="mb-4 text-3xl text-slate-800">Practice Setup</h1>
    <div class="flex flex-col gap-2 rounded-lg bg-white p-6 shadow-sm">
      @if (targetLaunchDate(); as launchDate) {
        <div class="flex items-center gap-2 text-sm text-slate-600">
          <mat-icon class="!text-base">event</mat-icon>
          <span
            ><strong>Target Launch Date:</strong>
            {{ launchDate | moment | amDateFormat: dateFormat }}</span
          >
        </div>
      }
      <div class="flex flex-col gap-2">
        <div class="progress-label flex justify-between text-gray-600">
          <span>Progress</span>
          <span>{{ store.completionPercentage() }}%</span>
        </div>
        <mat-progress-bar
          mode="determinate"
          [value]="store.completionPercentage()"
        />
      </div>
    </div>
  </div>

  @if (isWizardComplete()) {
    <div
      class="border-success-200 bg-success-50 flex items-center justify-between gap-3 rounded-lg border border-solid p-4"
    >
      <div class="flex items-center gap-3">
        <mat-icon class="text-success-600">celebration</mat-icon>
        <div class="flex flex-col">
          <span class="text-success-800 text-sm font-semibold"
            >Setup Complete</span
          >
          <span class="text-success-700 text-xs"
            >Congratulations! All steps have been completed. You can now dismiss
            the wizard.</span
          >
        </div>
      </div>
      <button
        mat-stroked-button
        color="primary"
        (click)="store.dismissWizard()"
      >
        <mat-icon>close</mat-icon>
        Dismiss
      </button>
    </div>
  }

  @if (store.loading()) {
    <div
      class="flex flex-col items-center justify-center rounded-lg bg-white p-16 text-center shadow-sm"
    >
      <mat-spinner diameter="40" />
      <p class="mt-4 text-slate-500">Loading setup wizard...</p>
    </div>
  } @else if (store.error()) {
    <div
      class="flex flex-col items-center justify-center rounded-lg bg-white p-16 text-center shadow-sm"
      role="alert"
    >
      <mat-icon color="warn" class="!mb-4 !h-12 !w-12 !text-5xl"
        >error</mat-icon
      >
      <p class="mt-4 text-slate-500">{{ store.error() }}</p>
      <button mat-button color="primary" class="mt-4" (click)="retry()">
        Retry
      </button>
    </div>
  } @else {
    <div class="content">
      <pr-setup-wizard-steps
        [categories]="store.categories()"
        [expandedCategories]="expandedCategories()"
        [showCategoryStatusStyles]="true"
        [showCompletionIcon]="true"
        (panelOpened)="onPanelOpened($event)"
        (panelClosed)="onPanelClosed($event)"
      />
    </div>
  }
</div>
